var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoolLightBox',{attrs:{"items":_vm.galleryItems,"index":_vm.galleryIndex,"thumbsPosition":"right","loop":true,"effect":"swipe"},on:{"close":function($event){_vm.galleryIndex = null}}})}
var staticRenderFns = []

export { render, staticRenderFns }